import template from './head.html';

export const headComponent = {
  name: 'head',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    body: '@'
  }
};
